import React, { useState, useEffect } from "react";
import {
    Row,
    Col,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from "reactstrap";
import Select from "react-select";
import SelectOptions from "components/SelectOptions"
import AreasService from "services/Admin/AreasService"
import DeveloperService from "services/Admin/DeveloperService"
import CountriesService from "services/Admin/CountriesService";
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { useDispatch } from "react-redux";
import { appendFilters } from "store/adminFilter/actions";

const initialState = {
    area: null,
    country: null,
    fromRate: "",
    toRate: "",
    location: null
}

const FilterModal = ({ modal, setModal, getList, updateFilter, filters }) => {
    const countriesService = new CountriesService()
    const areaService = new AreasService()
    const [AreaOptions, setAreaOptions] = useState([]);
    const [countriesOptions, setCountriesOptions] = useState([]);
    const [developerOptions, setDeveloperOptions] = useState([]);
    const [filterData, setFilterData] = useState(initialState);
    const dispatch = useDispatch()
    
    useEffect(() => {
        setFilterData((state) => ({ ...state, ...filters }))
    }, [])

    useEffect(() => {
        countriesService.getDropDown().then(res => {
            const newOptions = res.data?.map(item => {
                return {
                    label: item.name.en,
                    value: item.id
                }
            })
            setCountriesOptions(newOptions)
        })
    }, [])

    useEffect(() => {
        if(!!filterData?.country){
            areaService.getAreasDropDown(filterData?.country?.value).then(res => {
                const newOptions = res?.data?.map(item => {
                    return {
                        label: item.name.en,
                        value: item.id
                    }
                })
                setAreaOptions(newOptions)
            })
        }
    }, [filterData.country])

    const handleFieldChange = (e) => {
        const value= e.target.value
        setFilterData({ ...filterData, [e.target.name]: value });
    };

    return (
        <AvForm className='form-horizontal' >
        <Modal isOpen={modal} toggle={() => setModal(!modal)}
            className="rightModalSide scrollbar-container mt-0">
            <ModalHeader toggle={() => setModal(!modal)}>
                Compound Filters
        </ModalHeader>
            <ModalBody>
                <Col md={12}>
                    <label>Countries</label>
                    <Select
                        placeholder={"Select"}
                        options={countriesOptions}
                        onChange={(data) => {
                            setFilterData({...filterData, country : data, area: []})
                        }}
                        value={filterData?.country}
                    />
                </Col>
                <Col md={12} className='mt-3'>
                    <label>Location</label>
                    <Select
                        placeholder='Select'
                        noOptionsMessage={() => {
                            if(!filterData.country ){
                                return "Choose Country First"
                            }
                        }}
                        options={AreaOptions}
                        onChange={data => setFilterData({ ...filterData, area: data, location: data })}
                        value={filterData.location}
                        isMulti={true}
                    />
                </Col>
                <Row className="mt-4">
                    <h5 className="mb-3">Rate</h5>
                    <Col md={6} className="mb-3">
                        <AvField
                            name={"fromRate"}
                            label={"From"}
                            bsSize="lg"
                            value={filterData.fromRate}
                            onChange={(e => handleFieldChange(e))}
                            placeholder={'From'}
                            type="number"
                            min={"0"}
                            max={filterData.toRate}
                        />
                    </Col>
                    <Col md={6} className="mb-3">
                            <AvField
                                name={"toRate"}
                                label={"To"}
                                bsSize="lg"
                                value={filterData.toRate}
                                onChange={(e => handleFieldChange(e))}
                                 placeholder={'To'}
                                type="number"
                                min={"1"}
                                 max={"100"}
                            />
                        </Col>
                </Row>

            </ModalBody>
            <ModalFooter className="mt-4 px-0 d-flex justify-content-between">
                <button
                    type='button'
                    className='btn btn-light w-120'
                    onClick={() => {
                        dispatch(appendFilters({
                            country: null,
                            location: null,
                            area_ids: '',
                            fromRate: '',
                            toRate: ''
                        }))
                        setFilterData(initialState)
                        updateFilter(initialState)
                    }}>
                    Reset Filter
                            </button>
                <button
                    type='button'
                    onClick={() => {
                        let data = {}
                        if(!!filterData.country) data['country'] = filterData.country
                        data['location'] = !!filterData.location ? filterData.location : null
                        data['area_ids'] = !!filterData.location ? filterData.location?.map(item=> item.value).join() : ''
                        data['fromRate'] = filterData.fromRate
                        data['toRate'] = filterData.toRate

                        dispatch(appendFilters({...data}))
                        updateFilter(data)
                        setModal(false)
                    }}
                    className='btn btn-success  w-120'>
                    Apply Filter
                            </button>
            </ModalFooter>
        </Modal>
        </AvForm>
    )
}
export default FilterModal